import { render, staticRenderFns } from "./TopBarUser.vue?vue&type=template&id=20639de6&"
import script from "./TopBarUser.vue?vue&type=script&lang=js&"
export * from "./TopBarUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports